import React from 'react';

import { Search, X } from 'lucide-react';

const s = {
  pill: 'ml-auto flex items-center gap-2 bg-white/80 border-solid border border-neutral-400 rounded-full px-3 py-1 w-[271px]',
  input: 'flex-1 min-w-0 bg-transparent border-none outline-none text-sm text-neutral-700 placeholder:text-neutral-400',
  icon: 'w-3.5 h-3.5 text-[#a9a9a9] shrink-0',
  clearBtn: 'shrink-0 text-[#a9a9a9] hover:text-[#555] appearance-none bg-transparent border-0 p-0 cursor-pointer leading-none',
  clearIcon: 'w-3 h-3',
} as const;

interface SearchPillProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

/**
 * SearchPill — the rounded search box used above the Hit selection and Export summary tables.
 * Extracted so the two render the same control from one place. Hit selection keeps its query in
 * redux and Export summary in local state, so the value and setter are passed in rather than
 * read here — that is the only thing that differs between the two.
 */
export function SearchPill({ value, onChange, placeholder }: SearchPillProps) {
  return (
    <div className={s.pill}>
      <Search className={s.icon} />
      <input type="text" placeholder={placeholder} value={value} onChange={(event) => onChange(event.target.value)} className={s.input} />
      {value && (
        <button type="button" className={s.clearBtn} onClick={() => onChange('')} aria-label="Clear search">
          <X className={s.clearIcon} />
        </button>
      )}
    </div>
  );
}
